import { motion } from "framer-motion";

const shots = [
  {
    src: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1400&q=80",
    label: "Custom Residential — Lehigh Valley",
    tag: "Residential",
    tall: true,
  },
  {
    src: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1400&q=80",
    label: "Commercial Fit-Out — Allentown",
    tag: "Commercial",
  },
  {
    src: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1400&q=80",
    label: "Kitchen Renovation",
    tag: "Renovation",
  },
  {
    src: "https://images.unsplash.com/photo-1541123437800-1bb1317badc2?auto=format&fit=crop&w=1400&q=80",
    label: "Framing & New Build",
    tag: "New Build",
    tall: true,
  },
  {
    src: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1400&q=80",
    label: "Full Home Remodel",
    tag: "Residential",
  },
  {
    src: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=1400&q=80",
    label: "Warehouse & Industrial",
    tag: "Commercial",
  },
];

export default function Gallery() {
  return (
    <section
      id="work"
      data-testid="gallery-section"
      className="relative bg-[#050505] py-28 md:py-40"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <div className="grid gap-6 md:grid-cols-[1fr_1.4fr] md:items-end">
          <div>
            <div className="eyebrow">— Chapter Three · Selected Work</div>
            <h2 className="mt-6 font-oswald text-5xl uppercase leading-[0.9] tracking-tight text-white md:text-7xl">
              The proof
              <br />
              <span className="text-white/40">in the finish.</span>
            </h2>
          </div>
          <p className="max-w-xl font-editorial text-lg italic text-white/70 md:text-xl">
            A quiet selection of recent work — punch-list handyman jobs,
            ground-up new construction, and everything between.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-4 md:mt-20 md:grid-cols-4 md:gap-6">
          {shots.map((s, i) => (
            <motion.figure
              key={i}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{
                duration: 0.9,
                ease: [0.2, 0.8, 0.2, 1],
                delay: (i % 4) * 0.08,
              }}
              className={`group relative overflow-hidden border border-white/10 bg-[#0a0a0a] ${
                s.tall
                  ? "row-span-2 aspect-[3/4] md:aspect-[3/5]"
                  : "aspect-[4/5]"
              } ${i === 0 ? "col-span-2 md:col-span-2 md:row-span-2" : ""}`}
            >
              <img
                src={s.src}
                alt={s.label}
                loading="lazy"
                className="h-full w-full object-cover img-grayscale transition-transform duration-[1400ms] ease-out group-hover:scale-[1.06]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent opacity-90 transition-opacity duration-500 group-hover:opacity-100" />

              <figcaption className="absolute inset-x-0 bottom-0 flex items-end justify-between p-4 md:p-6">
                <span className="font-editorial text-base italic text-white md:text-lg">
                  {s.label}
                </span>
                <span className="font-mono text-[10px] uppercase tracking-widest text-white/70">
                  {s.tag}
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
